export const URL_TERMS_LINK = 'https://armcare.com/pages/terms-and-conditions-of-participation';
export const URL_POLICY_LINK = 'https://armcare.com/pages/privacy-policy';